import styled, { css } from 'styled-components';
import { Icon } from '../icon/index.js';
import {} from './index.js';
import { getMargins, SEM_TYPOGRAPHY_UI_MD_LABEL, SYS_SIZE_FIXED_700, SYS_SIZE_FIXED_900, SEM_BORDER_WIDTH_UI_DEFAULT, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_50, getTypographyStyles, SYS_SIZE_FIXED_150, SEM_TYPOGRAPHY_UI_SM_LABEL } from '@oneaudi/unified-web-common';
export const StyledLabel = styled.label `
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledButton = styled.button `
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  line-height: 0;
`;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;
export const StyledContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  box-sizing: border-box;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};
  ${(props) => props.size === 'md'
    ? getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_LABEL)
    : getTypographyStyles(SEM_TYPOGRAPHY_UI_SM_LABEL)};
  padding: ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_150};
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: background-color, box-shadow;
  min-height: ${(props) => props.size === 'md' ? SYS_SIZE_FIXED_900 : SYS_SIZE_FIXED_700};

  ${(props) => props.variant !== 'selectable' &&
    css `
      background-color: ${props.theme.cmp.color.ui.tag.surface.fill.default};
      color: ${props.theme.sem.color.ui.foreground.text.default};
    `}

  ${(props) => props.variant === 'selectable' &&
    props.disabled &&
    css `
      cursor: not-allowed;
      background-color: ${props.theme.cmp.color.ui.tag.unselected.surface.fill
        .disabled};
      box-shadow: inset 0 0 0 ${SEM_BORDER_WIDTH_UI_DEFAULT}
        ${props.theme.cmp.color.ui.tag.unselected.surface.stroke.disabled};
      color: ${(props) => props.theme.sem.color.ui.foreground.text.disabled};

      &:has(${StyledInput}:checked) {
        background-color: ${(props) => props.theme.cmp.color.ui.tag.selected.surface.fill.disabled};
      }
    `}

  ${(props) => props.variant === 'selectable' &&
    !props.disabled &&
    css `
      cursor: pointer;
      background-color: ${(props) => props.theme.cmp.color.ui.tag.unselected.surface.fill.default};
      box-shadow: inset 0 0 0 ${SEM_BORDER_WIDTH_UI_DEFAULT}
        ${(props) => props.theme.cmp.color.ui.tag.unselected.surface.stroke.default};

      &:hover,
      &:active {
        box-shadow: inset 0 0 0 ${SEM_BORDER_WIDTH_UI_DEFAULT}
          ${(props) => props.theme.cmp.color.ui.tag.unselected.surface.stroke.hover};
        background-color: ${(props) => props.theme.cmp.color.ui.tag.unselected.surface.fill.hover};
      }

      &:has(${StyledInput}:checked) {
        background-color: ${(props) => props.theme.cmp.color.ui.tag.selected.surface.fill.default};
        color: ${(props) => props.theme.sem.color.ui.foreground.text.default};
      }

      &:has(${StyledInput}:checked:hover) {
        background-color: ${(props) => props.theme.cmp.color.ui.tag.selected.surface.fill.hover};
      }

      &:has(${StyledInput}:focus-visible) {
        outline: auto;
      }
    `};
`;
export const StyledIcon = styled(Icon) `
  color: ${(props) => props.theme.sem.color.ui.foreground.icons.default};
  flex-shrink: 0;
`;
export const StyledOuterContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${(props) => props.size === 'md' ? SYS_SIZE_FIXED_150 : SYS_SPACE_FIXED_100};
`;
//# sourceMappingURL=index.styles.js.map